module.exports = __webpack_public_path__ + "img/miota.7237b8dc.svg";